<template>
  <label class="cliente-form-field" :class="{ 'has-error': error }">
    <span class="cliente-form-field__label">
      {{ label }}
      <span v-if="required" class="cliente-form-field__req">*</span>
    </span>
    <div class="cliente-form-field__control">
      <span v-if="$slots.icon" class="cliente-form-field__icon" aria-hidden="true">
        <slot name="icon" />
      </span>
      <textarea
        v-if="multiline"
        :value="modelValue"
        :rows="rows"
        :placeholder="placeholder"
        class="cliente-form-field__input cliente-form-field__textarea"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
      />
      <input
        v-else
        :value="modelValue"
        :type="type"
        :placeholder="placeholder"
        :inputmode="inputmode"
        class="cliente-form-field__input"
        @input="$emit('update:modelValue', $event.target.value)"
        @blur="$emit('blur')"
      />
    </div>
    <p v-if="error" class="cliente-form-field__error">{{ error }}</p>
    <p v-else-if="hint" class="cliente-form-field__hint">{{ hint }}</p>
  </label>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  modelValue: { type: String, default: '' },
  type: { type: String, default: 'text' },
  inputmode: { type: String, default: undefined },
  placeholder: { type: String, default: '' },
  required: { type: Boolean, default: false },
  error: { type: String, default: '' },
  hint: { type: String, default: '' },
  multiline: { type: Boolean, default: false },
  rows: { type: Number, default: 3 }
})

defineEmits(['update:modelValue', 'blur'])
</script>

<style scoped>
.cliente-form-field {
  display: block;
}
.cliente-form-field__label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-secondary, #64748b);
  margin-bottom: 0.375rem;
}
.cliente-form-field__req {
  color: #ef4444;
}
.cliente-form-field__control {
  display: flex;
  align-items: stretch;
  border-radius: 4px;
  border: 1px solid var(--border-primary, #e2e8f0);
  background: var(--bg-secondary, #fff);
  overflow: hidden;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.cliente-form-field.has-error .cliente-form-field__control {
  border-color: #f87171;
  box-shadow: 0 0 0 2px rgba(248, 113, 113, 0.2);
}
.cliente-form-field__control:focus-within {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15);
}
.cliente-form-field__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  flex-shrink: 0;
  color: #64748b;
  background: color-mix(in srgb, var(--bg-primary, #f8fafc) 80%, transparent);
  border-right: 1px solid var(--border-primary, #e2e8f0);
}
.cliente-form-field__icon :deep(svg) {
  width: 1.125rem;
  height: 1.125rem;
}
.cliente-form-field__input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0.625rem 0.75rem;
  font-size: 0.9375rem;
  color: var(--text-primary, #0f172a);
  outline: none;
}
.cliente-form-field__textarea {
  resize: vertical;
  min-height: 4.5rem;
}
.cliente-form-field__error {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: #dc2626;
}
.cliente-form-field__hint {
  margin: 0.25rem 0 0;
  font-size: 0.75rem;
  color: var(--text-secondary, #94a3b8);
}
</style>
